import { httpClient } from "@/app/old/desktop/shared/services/";
import { BaseService } from "@/app/old/desktop/shared/services/";
const URL = "fieldvalues";

class API extends BaseService {
  constructor() {
    super(null, URL);
  }

  bulk_update_field_values(req = {}) {
    return httpClient({
      url: `${this.url}/create-update/`,
      baseURL: this.baseURL,
      method: "post",
      data: req.body,
      header: req.headers,
    }).then(res => res.data);
  }
}

export const customFieldValuesService = new API();
